import axios from 'axios';
import { DetailsBooking } from 'types';
import { downloadFile, FileType } from './helpers';
import { throwWrappedAxiosError } from 'lib/errors';

const downloadInvoicePdf = async (booking: DetailsBooking, authHeader?: string) => {
  await axios({
    method: 'get',
    url: booking.links.downloadInvoice,
    responseType: 'blob',
    headers: { authorization: authHeader },
  })
    .then(({ data }) => downloadFile(`tax-invoice-${booking.reference}.pdf`, data, FileType['application/pdf']))
    .catch(throwWrappedAxiosError);
};

export default downloadInvoicePdf;
